import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type UserDeactivatedPayload = UserPayload;

export type UserDeactivatedAction = {
	type: 'USER_DEACTIVATED';
	payload: UserDeactivatedPayload;
	accountId: number;
};

export default (payload: UserDeactivatedPayload, accountId: number): UserDeactivatedAction => ({
	type: 'USER_DEACTIVATED',
	payload,
	accountId,
});
